import { render } from "./ProductoDestacado.vue?vue&type=template&id=18e6370f&scoped=true"
import script from "./ProductoDestacado.vue?vue&type=script&lang=js"
export * from "./ProductoDestacado.vue?vue&type=script&lang=js"

import "./ProductoDestacado.vue?vue&type=style&index=0&id=18e6370f&lang=scss&scoped=true"

import exportComponent from "/var/www/clients/client1/web6/web/cartamovil-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18e6370f"]])

export default __exports__